import Box from "@mui/material/Box";

import APIcon from "../buttons/APIcon";

type APComparisonScrollNavigationProps = {
  showLeft: boolean;
  showRight: boolean;
  onScrollLeft: () => void;
  onScrollRight: () => void;
};

const APComparisonScrollNavigation = ({
  showLeft,
  showRight,
  onScrollLeft,
  onScrollRight,
}: APComparisonScrollNavigationProps) => {
  const renderScrollButton = (direction: "left" | "right") => {
    return (
      <Box
        sx={{
          height: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          pointerEvents: "auto",
        }}
        onClick={direction === "left" ? onScrollLeft : onScrollRight}
      >
        <APIcon name={direction === "left" ? "arrow-left" : "arrow-right"} />
      </Box>
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Box>{showLeft && renderScrollButton("left")}</Box>
      <Box>{showRight && renderScrollButton("right")}</Box>
    </Box>
  );
};

export default APComparisonScrollNavigation;
